module.exports = __webpack_public_path__ + "img/ZW.bc893918.svg";